import useSendReportEmail from './useSendReportEmail';

export { useSendReportEmail };
